<template>
  <footer class="fst-footer">
    <!-- 主内容区 -->
    <div class="fst-footer__main">
      <div class="fst-footer__container">
        <!-- Column 1: Brand + Social -->
        <div class="fst-footer__col fst-footer__col--brand">
          <div class="fst-footer__brand-hd">
            <img src="@/assets/images/fst4fa53ebf.png" alt="FST" class="fst-footer__brand-logo" />
            <div class="fst-footer__brand-text">
              <h3 class="fst-footer__brand-title">{{ $t('footer.title') }}</h3>
              <p class="fst-footer__brand-desc">{{ $t('footer.contactPrompt')}}</p>
            </div>
          </div>
          <!-- 社交平台 -->
          <div class="fst-footer__social-grid">
            <!-- 泛思特小程序 -->
            <div class="fst-footer__social">
              <a href="javascript:;" class="fst-footer__social-icon" :aria-label="$t('footer.social.fanstar')">
                <svg class="fst-footer__icon-svg" viewBox="0 0 72 72" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <g fill="currentColor" fill-rule="nonzero">
                    <path d="M49,9 C45.693,9 42.614,9.879 40,11.374 C35.205,14.118 32,18.968 32,24.5 L32,47.5 C32,51.642 27.97,55 23,55 C18.029,55 14,51.642 14,47.5 C14,44.552 16.046,42.009 19.015,40.783 C19.229,40.695 19.446,40.611 19.669,40.537 C21.538,39.787 23.141,38.379 23.736,36.744 C24.615,34.33 22.979,32.374 20.083,32.374 C19.361,32.374 18.629,32.496 17.923,32.716 C17.92,32.717 17.917,32.718 17.913,32.719 C13.726,33.921 10.231,36.557 8.133,40 C6.778,42.225 6,44.78 6,47.5 C6,56.047 13.626,63 23,63 C26.307,63 29.386,62.121 32,60.626 C36.795,57.882 40,53.032 40,47.5 L40,24.5 C40,20.358 44.029,17 49,17 C53.97,17 58,20.358 58,24.5 C58,27.574 55.781,30.216 52.604,31.374 C50.555,32.061 48.876,33.544 48.236,35.301 C47.362,37.703 48.99,39.651 51.873,39.651 C52.526,39.651 53.186,39.539 53.829,39.357 C53.934,39.328 54.038,39.296 54.142,39.265 C58.304,38.056 61.778,35.428 63.866,32 C65.222,29.776 66,27.22 66,24.5 C66,15.953 58.374,9 49,9" />
                  </g>
                </svg>
              </a>
              <span class="fst-footer__social-label">{{ $t('footer.social.fanstar') }}</span>
              <div class="fst-footer__qr">
                <div class="fst-footer__qr-card">
                  <div class="fst-footer__qr-head">
                    <div class="fst-footer__qr-icon"><img v-lazy-img="require('@/assets/images/gzh.jpg')" :alt="$t('footer.qrIconAlt')" /></div>
                    <div class="fst-footer__qr-name">{{ $t('footer.social.fanstar') }}</div>
                  </div>
                  <div class="fst-footer__qr-img"><img v-lazy-img="require('@/assets/images/xiaochengxu.jpg')" :alt="$t('footer.qrCodeAlt')" /></div>
                  <div class="fst-footer__qr-hint">{{ $t('footer.social.fanstarHint') }}</div>
                </div>
              </div>
            </div>

            <!-- 鉴定宝 -->
            <div class="fst-footer__social">
              <a href="javascript:;" class="fst-footer__social-icon" :aria-label="$t('footer.social.jdb')">
                <svg class="fst-footer__icon-svg" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
                  <g fill="currentColor" fill-rule="nonzero">
                    <path d="M49,9 C45.693,9 42.614,9.879 40,11.374 C35.205,14.118 32,18.968 32,24.5 L32,47.5 C32,51.642 27.97,55 23,55 C18.029,55 14,51.642 14,47.5 C14,44.552 16.046,42.009 19.015,40.783 C19.229,40.695 19.446,40.611 19.669,40.537 C21.538,39.787 23.141,38.379 23.736,36.744 C24.615,34.33 22.979,32.374 20.083,32.374 C19.361,32.374 18.629,32.496 17.923,32.716 C17.92,32.717 17.917,32.718 17.913,32.719 C13.726,33.921 10.231,36.557 8.133,40 C6.778,42.225 6,44.78 6,47.5 C6,56.047 13.626,63 23,63 C26.307,63 29.386,62.121 32,60.626 C36.795,57.882 40,53.032 40,47.5 L40,24.5 C40,20.358 44.029,17 49,17 C53.97,17 58,20.358 58,24.5 C58,27.574 55.781,30.216 52.604,31.374 C50.555,32.061 48.876,33.544 48.236,35.301 C47.362,37.703 48.99,39.651 51.873,39.651 C52.526,39.651 53.186,39.539 53.829,39.357 C53.934,39.328 54.038,39.296 54.142,39.265 C58.304,38.056 61.778,35.428 63.866,32 C65.222,29.776 66,27.22 66,24.5 C66,15.953 58.374,9 49,9" />
                  </g>
                </svg>
              </a>
              <span class="fst-footer__social-label">{{ $t('footer.social.jdb') }}</span>
              <div class="fst-footer__qr">
                <div class="fst-footer__qr-card">
                  <div class="fst-footer__qr-head">
                    <div class="fst-footer__qr-icon"><img v-lazy-img="require('@/assets/images/logo.png')" :alt="$t('footer.jdbIconAlt')" /></div>
                    <div class="fst-footer__qr-name">{{ $t('footer.social.jdb') }}</div>
                  </div>
                  <div class="fst-footer__qr-img"><img v-lazy-img="require('@/assets/images/jiandingbao.jpg')" :alt="$t('footer.jdbQrAlt')" /></div>
                  <div class="fst-footer__qr-hint">{{ $t('footer.social.jdbHint') }}</div>
                </div>
              </div>
            </div>

            <!-- 抖音 -->
            <div class="fst-footer__social fst-footer__social--plain">
              <a href="javascript:void(0)" class="fst-footer__social-icon" :aria-label="$t('footer.social.douyin')" @click.prevent="openExternal('https://www.douyin.com/user/MS4wLjABAAAAxD3qTDDJc_RIUMY9-OcAad7l1MXK3WjXe3qZ8ceHf8E')">
                <svg class="fst-footer__icon-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" fill="currentColor"/>
                </svg>
              </a>
              <span class="fst-footer__social-label">{{ $t('footer.social.douyin') }}</span>
            </div>

            <!-- 小红书 -->
            <div class="fst-footer__social fst-footer__social--plain">
              <a href="javascript:void(0)" class="fst-footer__social-icon fst-footer__social-icon--xhs" :aria-label="$t('footer.social.xhs')" @click.prevent="openExternal('https://www.xiaohongshu.com/user/profile/62cbec990000000002003b85')">
                <svg viewBox="0 0 1024 1024" class="fst-footer__icon-svg" xmlns="http://www.w3.org/2000/svg">
                  <rect class="xhs-bg" x="0" y="0" width="1024" height="1024" rx="180" ry="180" />
                  <text x="50%" y="55%" text-anchor="middle" font-size="320" font-weight="bold" font-family="sans-serif" class="xhs-text" dominant-baseline="middle">{{ $t('footer.social.xhsIcon') }}</text>
                </svg>
              </a>
              <span class="fst-footer__social-label">{{ $t('footer.social.xhs') }}</span>
            </div>
          </div>
        </div>

        <!-- Column 2: Quick Links -->
        <div class="fst-footer__col">
          <h4 class="fst-footer__col-title">{{ $t('footer.columns.quickLinks') }}</h4>
          <div class="fst-footer__links-wrap">
            <ul class="fst-footer__links">
              <li><router-link to="/">{{ $t('footer.links.home') }}</router-link></li>
              <li><router-link to="/about">{{ $t('footer.links.about') }}</router-link></li>
              <li><router-link to="/services/shipping">{{ $t('footer.links.shipping') }}</router-link></li>
              <li><router-link to="/services/refrigerated">{{ $t('footer.links.refrigerated') }}</router-link></li>
            </ul>
            <ul class="fst-footer__links">
              <li><router-link to="/services/operable">{{ $t('footer.links.operable') }}</router-link></li>
              <li><router-link to="/services/consultation">{{ $t('footer.links.consultation') }}</router-link></li>
              <li><router-link to="/contact/business">{{ $t('footer.links.business') }}</router-link></li>
              <li><router-link to="/contact/careers">{{ $t('footer.links.careers') }}</router-link></li>
            </ul>
          </div>
        </div>
        <!-- Column 3: Contact Info -->
        <div class="fst-footer__col">
          <h4 class="fst-footer__col-title">{{ $t('footer.columns.contactInfo') }}</h4>
          <ul class="fst-footer__contacts">
            <li class="fst-footer__contact-item">
              <i class="fst-footer__contact-icon el-icon-location-outline"></i>
              <span>{{ $t('footer.address') }}</span>
            </li>
            <li class="fst-footer__contact-item">
              <i class="fst-footer__contact-icon el-icon-chat-dot-round"></i>
              <span>{{ $t('footer.qq') }}</span>
            </li>
            <li class="fst-footer__contact-item">
              <i class="fst-footer__contact-icon">
                <svg viewBox="0 0 1024 1024" class="fst-footer__contact-svg" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M256 128h512c35.2 0 64 28.8 64 64v96c0 35.2-28.8 64-64 64H704v64h64c35.2 0 64 28.8 64 64v288c0 35.2-28.8 64-64 64H256c-35.2 0-64-28.8-64-64V480c0-35.2 28.8-64 64-64h64v-64H256c-35.2 0-64-28.8-64-64v-96c0-35.2 28.8-64 64-64z m64 352v192h384V480H320z m128 64h128v64H448v-64z m-64-288h320v-64H384v64z"/></svg>
              </i>
              <span>{{ $t('footer.fax') }}</span>
            </li>
            <li class="fst-footer__contact-item">
              <i class="fst-footer__contact-icon">
                <svg viewBox="0 0 1024 1024" class="fst-footer__contact-svg" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M320 64h384c35.2 0 64 28.8 64 64v768c0 35.2-28.8 64-64 64H320c-35.2 0-64-28.8-64-64V128c0-35.2 28.8-64 64-64z m32 96v640h320V160H352z m96 672h128v48H448v-48z"/></svg>
              </i>
              <span>{{ $t('footer.phone') }}</span>
            </li>
            <li class="fst-footer__contact-item">
              <i class="fst-footer__contact-icon el-icon-message"></i>
              <span>{{ $t('footer.email') }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 飞机 -->
    <!-- <div class="fst-footer__plane">
      <div class="fst-footer__plane-pin">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z" fill="currentColor"/></svg>
      </div>
      <img src="@/assets/images/shape_11.png" alt="plane" class="fst-footer__plane-img" />
    </div> -->

    <!-- 道路与交通工具装饰层 -->
    <div class="fst-footer__track">

      <!-- 小汽车 -->
      <div class="fst-footer__car">
        <img v-lazy-img="require('@/assets/images/shape_11.png')" alt="car" class="fst-footer__car-img" />
      </div>
      <div class="fst-footer__track-line">
        <div class="fst-footer__track-arrows">
          <span></span><span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span><span></span>
        </div>
      </div>
    </div>

    <!-- 底部波浪装饰 -->
    <div class="fst-footer__waves">
      <svg viewBox="0 0 1440 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0,60 C240,120 480,0 720,60 C960,120 1200,0 1440,60 L1440,120 L0,120 Z" fill="rgba(10,27,42,0.6)"/>
        <path d="M0,80 C360,140 720,20 1080,80 C1260,110 1350,90 1440,100 L1440,120 L0,120 Z" fill="rgba(10,27,42,0.8)"/>
      </svg>
    </div>

    <!-- 底部版权栏 -->
    <div class="fst-footer__bottom">
      <div class="fst-footer__bottom-inner">
        <div class="fst-footer__copyright">{{ $t('footer.copyright') }}</div>
        <div class="fst-footer__beian">
          <a class="fst-footer__beian-link" target="_blank" :href="$t('footer.beian.publicSecurityUrl')">{{ $t('footer.beian.publicSecurity') }}</a>
          <span class="fst-footer__beian-sep">|</span>
          <a class="fst-footer__beian-link" target="_blank" :href="$t('footer.beian.icpUrl')">{{ $t('footer.beian.icp') }}</a>
        </div>
      </div>
    </div>

    <!-- 回到顶部 -->
    <button class="fst-footer__back-top" @click="scrollToTop" :aria-label="$t('footer.backTop')">
      <img src="../assets/icons/plane-up.svg" class="back-top-img" :alt="$t('footer.backTop')" />
    </button>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    openExternal(url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
};
</script>

<style scoped lang="scss">
/* =====================================================================
   FANSTAR FOOTER · 重构版 — 分隔线布局 + 微光叠加 + 精致交互
   ===================================================================== */

/* ===== 根容器 ===== */
.fst-footer {
  position: relative;
  color: #ffffff;
  font-family: 'Inter', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 18px;
  line-height: 1.875em;
  overflow: visible;
  border-radius: 20px;
  // background moved to &::before for QR popup compatibility

  /* 暗色叠加 + 背景图 + 微光效果（优化：降低遮罩透明度 + 暖色桥接） */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: #0d1b2a;
    // background:
    //   radial-gradient(ellipse at 70% 20%, rgba(0, 82, 204, 0.10) 0%, transparent 50%),
    //   radial-gradient(ellipse at 20% 80%, rgba(0, 82, 204, 0.06) 0%, transparent 50%),
    //   /* 优化：降低不透明度 + 暖色中间调桥接日落天空→深海军蓝 */
    //   linear-gradient(180deg,
    //     rgba(13, 27, 42, 0.50) 0%,
    //     rgba(13, 27, 42, 0.40) 25%,
    //     rgba(30, 28, 40, 0.55) 45%,
    //     rgba(13, 27, 42, 0.65) 65%,
    //     rgba(13, 27, 42, 0.78) 100%),
    //   url('~@/assets/images/footer1.png') center center / cover no-repeat #0d1b2a;
    border-radius: inherit;
    pointer-events: none;
    z-index: 0;
  }

}

/* 所有内容层级提升 */
.fst-footer__main,
.fst-footer__track,
.fst-footer__plane,
.fst-footer__waves,
.fst-footer__bottom,
.fst-footer__back-top {
  position: relative;
  z-index: 1;
}

/* ===== 主内容区 ===== */
.fst-footer__main {
  padding: 56px 40px 40px;
}

.fst-footer__container {
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.4fr 1fr 1.1fr;
  gap: 0;
}

/* ===== 列通用 ===== */
.fst-footer__col {
  position: relative;
  padding: 0 36px;

  /* 列分隔线 */
  &:not(:first-child)::before {
    content: '';
    position: absolute;
    left: 0;
    top: 8px;
    bottom: 40px;
    width: 1px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.03) 100%);
  }

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
}

/* ===== Brand Column ===== */
.fst-footer__col--brand {
  padding-top: 0;
  padding-bottom: 0;
}

.fst-footer__brand-hd {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}

.fst-footer__brand-logo {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  object-fit: contain;
  background: #ffffff;
  padding: 6px;
  flex-shrink: 0;
  // box-shadow: 0 4px 16px rgba(0, 82, 204, 0.2);
}

.fst-footer__brand-text {
  flex: 1;
}

.fst-footer__brand-title {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 4px;
  letter-spacing: 1px;
  line-height: 1.4;
}

.fst-footer__brand-desc {
  font-size: 15px;
  color: #ffffff;
  line-height: 1.7;
  margin: 0;
}

/* ===== Column Titles ===== */
.fst-footer__col-title {
  font-size: 17px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 20px;
  letter-spacing: 1px;
  position: relative;
  padding-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 10px;

  /* 左侧竖条 */
  &::before {
    content: '';
    display: inline-block;
    width: 3px;
    height: 16px;
    background: #0052CC;
    border-radius: 2px;
    flex-shrink: 0;
  }

  /* 底部渐变线 */
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, rgba(0, 82, 204, 0.4) 0%, rgba(0, 82, 204, 0.05) 100%);
  }
}

/* ===== Links — 双列紧凑 ===== */
.fst-footer__links-wrap {
  display: flex;
  gap: 24px;
}

.fst-footer__links {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
  min-width: 0;
}

.fst-footer__links li {
  margin-bottom: 0;
}

.fst-footer__links a {
  font-size: 15px;
  color: #ffffff;
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  position: relative;
  white-space: nowrap;

  /* hover 展开小横线 */
  &::before {
    content: '';
    display: inline-block;
    width: 0;
    height: 1px;
    background: #0052CC;
    transition: width 0.3s ease;
    flex-shrink: 0;
  }

  &:hover {
    color: #ffffff;
    padding-left: 4px;

    &::before {
      width: 10px;
    }
  }
}

/* ===== Contact Info ===== */
.fst-footer__contacts {
  list-style: none;
  padding: 0;
  margin: 0;
}

.fst-footer__contact-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 16px;
  font-size: 15px;
  color: #ffffff;
  line-height: 1.7;
  transition: color 0.3s ease;

  &:hover {
    color: #ffffff;
  }
}

.fst-footer__contact-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: rgba(0, 82, 204, 0.12);
  border: 1px solid rgba(0, 82, 204, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4d9aff;
  font-size: 15px;
  flex-shrink: 0;
  transition: all 0.35s ease;
}

.fst-footer__contact-svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
  color: inherit;
}

.fst-footer__contact-item:hover .fst-footer__contact-icon {
  background: rgba(0, 82, 204, 0.25);
  border-color: rgba(0, 82, 204, 0.4);
  color: #ffffff;
  box-shadow: 0 0 16px rgba(0, 82, 204, 0.15);
  transform: scale(1.05);
}

/* ===== 社交图标 — 2x2 网格 ===== */
.fst-footer__social-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 14px;
  margin-top: 8px;
}

.fst-footer__social {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  &:hover {
    background: rgba(0, 82, 204, 0.15);
    border-color: rgba(0, 82, 204, 0.25);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 82, 204, 0.12);

    .fst-footer__social-label {
      color: #ffffff;
    }
  }
}

.fst-footer__social:hover .fst-footer__qr {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.fst-footer__social-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  color: #0d1b2a;
  flex-shrink: 0;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  cursor: pointer;
  overflow: hidden;
  text-decoration: none;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    top: 0;
    left: 0;
    transform: scale(0);
    background: #0052CC;
    transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: -1;
  }

  .fst-footer__social:hover & {
    color: #ffffff;
    box-shadow: 0 2px 10px rgba(0, 82, 204, 0.3);

    &::before {
      transform: scale(1);
    }
  }
}

.fst-footer__social-icon--xhs {
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 0;
}
.fst-footer__social-icon--xhs .xhs-bg { fill: transparent; transition: fill 0.3s ease; }
.fst-footer__social-icon--xhs .xhs-text { fill: #0d1b2a; transition: fill 0.3s ease; }

.fst-footer__social:hover .fst-footer__social-icon--xhs .xhs-bg { fill: #0052CC; }
.fst-footer__social:hover .fst-footer__social-icon--xhs .xhs-text { fill: #ffffff; }

.fst-footer__icon-svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
  color: inherit;
  transition: all 0.3s ease-in-out;
}

.fst-footer__social-label {
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.3px;
  transition: color 0.3s ease;
}

/* ===== QR popup — 图标上方弹出 ===== */
.fst-footer__qr {
  position: absolute;
  bottom: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  width: 180px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.45s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 20;
  pointer-events: none;
}

.fst-footer__qr::before {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 10px 10px 0;
  border-style: solid;
  border-color: #ffffff transparent transparent;
}

.fst-footer__qr-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.3), 0 8px 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  padding: 12px;
  text-align: center;
}

.fst-footer__qr-head { margin-bottom: 8px; }

.fst-footer__qr-icon {
  width: 38px;
  height: 38px;
  margin: 0 auto 5px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(11, 31, 58, 0.08), 0 1px 2px rgba(11, 31, 58, 0.04);
}

.fst-footer__qr-icon img { width: 100%; height: 100%; object-fit: cover; }

.fst-footer__qr-name { font-size: 14px; font-weight: 600; color: #0a1628; }

.fst-footer__qr-img {
  width: 110px;
  height: 110px;
  margin: 0 auto 6px;
  padding: 4px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
}

.fst-footer__qr-img img { width: 100%; height: 100%; object-fit: cover; border-radius: 2px; }

.fst-footer__qr-hint { font-size: 12px; color: #64748b; }

/* ===== 底部版权栏 ===== */
.fst-footer__bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 18px 40px;
}

.fst-footer__bottom-inner {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fst-footer__copyright {
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.3px;
}

.fst-footer__beian {
  display: flex;
  align-items: center;
  gap: 10px;
}

.fst-footer__beian-link {
  font-size: 14px;
  color: #ffffff;
  text-decoration: none;
  transition: color 0.25s ease;

  &:hover {
    color: #4d9aff;
  }
}

.fst-footer__beian-sep {
  color: rgba(255, 255, 255, 0.12);
  font-size: 11px;
}

/* ===== 道路与交通工具装饰 ===== */
.fst-footer__track {
  position: relative;
  width: 100%;
  height: 40px;
  z-index: 1;
  overflow: hidden;
}

.fst-footer__track-line {
  position: absolute;
  top: 18px;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.12) 15%, rgba(255, 255, 255, 0.12) 85%, transparent 100%);
}

.fst-footer__track-arrows {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  display: flex;
  gap: 80px;
  width: 100%;
  justify-content: space-around;
  padding: 0 10%;

  span {
    display: block;
    width: 0;
    height: 0;
    border-top: 3px solid transparent;
    border-bottom: 3px solid transparent;
    border-left: 8px solid rgba(255, 255, 255, 0.15);
  }
}

/* 小汽车 — 从左向右无限行驶（优化：柔化阴影 + 蓝色光尾迹） */
.fst-footer__car {
  position: absolute;
  top: 2px;
  left: -80px;
  animation: carDrive 35s linear infinite;
  display: flex;
  flex-direction: column;
  align-items: center;
  filter: drop-shadow(0 1px 5px rgba(0, 82, 204, 0.20));

  /* 蓝色光尾迹 */
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translateY(-50%);
    width: 70px;
    height: 18px;
    background: radial-gradient(ellipse at right center,
      rgba(0, 82, 204, 0.22) 0%,
      rgba(0, 82, 204, 0.08) 50%,
      transparent 100%);
    border-radius: 50%;
    pointer-events: none;
    z-index: -1;
  }
}

.fst-footer__car-img {
  height: 36px;
  object-fit: cover;
  object-position: top;
}

@keyframes carDrive {
  0% { left: -80px; }
  100% { left: calc(100% + 80px); }
}

/* 飞机 — 右上角浮动（优化：大气光晕 + 提升不透明度 + 蓝色阴影统一色温） */
.fst-footer__plane {
  position: absolute;
  top: 30px;
  right: 50px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: planeFloat 4s ease-in-out infinite;
  opacity: 0.85;

  /* 大气光晕 */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90px;
    height: 50px;
    background: radial-gradient(ellipse at center,
      rgba(0, 82, 204, 0.12) 0%,
      rgba(0, 82, 204, 0.05) 50%,
      transparent 100%);
    pointer-events: none;
    z-index: -1;
  }
}

.fst-footer__plane-pin {
  width: 14px;
  height: 14px;
  color: #4d9aff;
  margin-bottom: 2px;
  filter: drop-shadow(0 0 4px rgba(77, 154, 255, 0.3));

  svg {
    width: 100%;
    height: 100%;
  }
}

.fst-footer__plane-img {
  width: 52px;
  height: 26px;
  object-fit: cover;
  object-position: top;
  filter: drop-shadow(0 1px 4px rgba(0, 82, 204, 0.18)) brightness(1.05);
}

@keyframes planeFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

/* 底部波浪 */
.fst-footer__waves {
  display: none;
}

/* ===== 回到顶部 — 圆形品牌蓝 ===== */
.fst-footer__back-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #0052CC;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0, 82, 204, 0.35);
  transition: all 0.3s ease-in-out;
  z-index: 999;
  padding: 0;

  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    top: 100%;
    left: 5%;
    height: 10px;
    width: 90%;
    background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0) 80%);
  }

  .back-top-img {
    width: 20px;
    height: 20px;
    object-fit: contain;
    filter: brightness(0) invert(1);
    transition: transform 0.3s ease;
  }

  &:hover {
    background: #0043A8;
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(0, 82, 204, 0.45);

    .back-top-img {
      transform: translateY(-2px);
    }
  }
}

/* ===== 响应式 ===== */
@media (min-width: 1536px) {
  .fst-footer__container,
  .fst-footer__bottom-inner {
    max-width: 1440px;
  }
}

@media (min-width: 1920px) {
  .fst-footer__container,
  .fst-footer__bottom-inner {
    max-width: 1640px;
  }
}

@media (max-width: 1024px) {
  .fst-footer__main { padding: 40px 32px 32px; }
  .fst-footer__bottom { padding: 20px 32px; }

  .fst-footer__container {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }

  .fst-footer__col {
    padding: 0;

    &:first-child {
      grid-column: 1 / -1;
      padding: 0;
    }

    &:not(:first-child)::before {
      display: none;
    }
  }

  .fst-footer__social-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .fst-footer__main { padding: 32px 20px 24px; }
  .fst-footer__bottom { padding: 15px 20px; }
  .fst-footer__brand-desc { font-size: 15px; }

  .fst-footer__container {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .fst-footer__col {
    padding: 0;

    &:first-child {
      grid-column: auto;
    }

    &:not(:first-child)::before {
      display: none;
    }
  }

  .fst-footer__social-grid {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .fst-footer__links-wrap {
    gap: 20px;
  }

  .fst-footer__bottom-inner {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .fst-footer__beian {
    justify-content: center;
  }

  .fst-footer__back-top {
    bottom: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
  }

  .fst-footer__col-title {
    font-size: 16px;
    margin-bottom: 16px;
  }
}

@media (max-width: 480px) {
  .fst-footer__col-title { font-size: 15px; }
  .fst-footer__brand-title { font-size: 20px; }
  .fst-footer__brand-hd { flex-direction: column; gap: 12px; align-items: flex-start; }
  .fst-footer__brand-logo { width: 44px; height: 44px; }
  .fst-footer__social-grid { gap: 6px; }
  .fst-footer__social { padding: 8px 10px; gap: 8px; }
  .fst-footer__social-icon { width: 32px; height: 32px; }
  .fst-footer__social-label { font-size: 11px; }
  .fst-footer__links-wrap { flex-direction: column; gap: 0; }
}
</style>
